import styled, { css } from 'react-emotion';

const direction = (show, direction) => {
  const sign = direction === 'left' ? '-' : '';

  return show ? 'none' : `translateX(${sign}102%);`;
};

export const getDirectionOffset = direction => {
  const xOffset = direction === 'left' ? 'left' : 'right';
  return css`
    ${xOffset}: 0;
  `;
};

// @width
// TODO: find abstraction for transitions
export const Overlay = styled('div')`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: ${props => (props.show ? 1 : 0)};
  background: rgba(0, 0, 0, 0.4);
  transition: opacity 0.15s cubic-bezier(0, 0, 0.3, 1);
  will-change: opacity;
  pointer-events: none;
`;

// @width
// @overflow
export const Aside = styled('aside')`
  position: absolute;
  overflow: hidden;
  pointer-events: ${props => (props.show ? 'auto' : 'none')};
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
`;

// TODO: find abstraction for transitions
// @width
// @box-shadow
export const Content = styled('div')`
  position: absolute;
  height: 100%;
  transform: ${props => direction(props.show, props.expandDirection)};
  transition: transform 0.5s cubic-bezier(0, 0, 0.3, 1);
  will-change: transform;
  width: ${props => (props.expandWidth ? props.expandWidth : undefined)};
  background: white;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.4);

  @media screen and (min-width: 40em) {
    max-width: ${props => (props.maxWidth ? '50%' : '440px')};
  }

  @media screen and (min-width: 52em) {
    max-width: ${props => (props.maxWidth ? '33vw' : '440px')};
  }

  @media screen and (min-width: 76em) {
    max-width: ${props => (props.maxWidth ? '380px' : '440px')};
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/sidepanel/style.js